import { gql } from '@apollo/client';

export const MyNotificationSetting = gql`
  query MyNotificationSetting {
    myNotificationSetting {
      id
      eventRegistrationOpen
      eventRegistrationClosingReminder
      eventRegistrationClosed
      eventUpcomingReminder
      newAnnouncement
      weightUpdateReminder
      eventRegistrationOpenEmail
      eventRegistrationClosingReminderEmail
      eventRegistrationClosedEmail
      eventUpcomingReminderEmail
      newAnnouncementEmail
      weightUpdateReminderEmail
    }
  }
`;
